module.exports = __webpack_public_path__ + "media/images/login/link_btn-61f07bd2360e6e2af97c2980132190e1.png";